import { UserManager } from "oidc-client-ts";
import { useEffect } from "react";

import { readOidcConfig } from "./config";

function manager(): UserManager | null {
  const cfg = readOidcConfig();
  if (!cfg) return null;
  const origin = window.location.origin;
  return new UserManager({
    authority: cfg.authority,
    client_id: cfg.clientId,
    redirect_uri: `${origin}/acceso/callback`,
    popup_redirect_uri: `${origin}/acceso/callback`,
    silent_redirect_uri: `${origin}/acceso/silent`,
    response_type: "code",
    scope: "openid profile email",
  });
}

/** The landing page Keycloak returns to after a full-page sign-in redirect.
    Completes the Authorization-Code exchange (persisting the session to
    localStorage, the same store `wireSession` hydrates from on boot), then sends
    the browser back to the app. On any failure — the visitor cancelled at
    Keycloak, or the code is stale on a back-button revisit — it still returns to
    the portada rather than stranding a blank page. */
export function RedirectCallback() {
  useEffect(() => {
    const done = () => window.location.replace("/");
    const mgr = manager();
    if (!mgr) {
      done();
      return;
    }
    mgr.signinRedirectCallback().then(done, done);
  }, []);
  return null;
}

/** Runs in the hidden silent-renew iframe. */
export function SilentCallback() {
  useEffect(() => {
    manager()
      ?.signinSilentCallback()
      .catch(() => {});
  }, []);
  return null;
}
